<footer class="footer">
    <div class="container-fluid">
        <nav class="pull-left">
            <ul><li>
                    <a href="/">
                        SanlamAllianz Madagascar
                    </a>
                </li>
            </ul>
        </nav>
        <div class="copyright pull-right">
          &copy; {{test | date: 'yyyy'}}, developed by <a href="https://www.tapakila.mg">TAPAKILA</a>    </div>
    </div>
</footer>



// WEBPACK FOOTER //
// ./src/app/shared/footer/footer.component.html